import IconCopy from "app/components/Icon/components/IconCopy/IconCopy";
import { DepositDetailsType } from "app/types/cryptoType";
import { CryptoCurrencyTypes } from "app/utils/const";
import { QRCodeSVG } from "qrcode.react";
import React, { Component, MouseEventHandler } from "react";
import { FormattedMessage } from "react-intl";
import "./CryptoFundingDepositNew.scss";
type Props = {
  depositDetails: DepositDetailsType;
  completeQuote: MouseEventHandler;
  cancelDeposit: MouseEventHandler;
  copyWalletAddress: MouseEventHandler;
};

class CryptoFundingDepositNew extends Component<Props> {
  getQRCodeValue = () => {
    const { depositDetails } = this.props;
    switch (depositDetails.selectedCoin) {
      case CryptoCurrencyTypes.BTC:
        return `${depositDetails.deposit_address}?amount=${depositDetails.receiveQuantity}`;
      case CryptoCurrencyTypes.USDT_ERC20:
        return `${depositDetails.deposit_address}?amount=${depositDetails.receiveQuantity}`;
      case CryptoCurrencyTypes.USDT_TRC20:
        return `${depositDetails.deposit_address}?amount=${depositDetails.receiveQuantity}`;
      case CryptoCurrencyTypes.ETH:
        return `${depositDetails.deposit_address}?amount=${depositDetails.receiveQuantity}`;
      default:
        return "";
    }
  };
  render() {
    const { depositDetails, completeQuote, cancelDeposit, copyWalletAddress } =
      this.props;
    console.log("depositDetails", depositDetails);
    return (
      <React.Fragment>
        <div className="crypto-funding-deposit-new__address-info">
          <div className="crypto-funding-deposit-new__title">
            <FormattedMessage id="cashier-wallet-address" />
          </div>
          <div className="crypto-funding-deposit-new__qr-code">
            <QRCodeSVG value={this.getQRCodeValue()} />
          </div>
          <div className="crypto-funding-deposit-new__wallet-address">
            <input
              type="text"
              value={depositDetails.deposit_address || ""}
              disabled={true}
            />
            <IconCopy onClick={copyWalletAddress} />
          </div>
          <FormattedMessage id="cashier-address-transfer-message" />
        </div>
        <div className="crypto-funding-deposit-new__buttons-section">
          <div className="crypto-funding-deposit-new__buttons-section__buttons">
            <button onClick={completeQuote}>
              <FormattedMessage tagName="span" id="cashier-confirm-deposit" />
            </button>
            <button className="error-button" onClick={cancelDeposit}>
              <FormattedMessage tagName="span" id="button-cancel" />
            </button>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default CryptoFundingDepositNew;
